import { lazy } from "react";

const Cms = lazy(() => import("../pages/Cms"));
const Login = lazy(() => import("../pages/Login"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const ArtWorkManagement = lazy(() => import("../pages/ArtWorkManagement"));
const Notifications = lazy(() => import("../pages/Notifications"));
const Settings = lazy(() => import("../pages/Settings"));
const ViewUser = lazy(() => import("../pages/ViewUser"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const Cruds = lazy(() => import("../pages/Cruds"));

export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    element: <Login />,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    element: <Dashboard />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    element: <UserManagement />,
  },
  {
    path: "/user-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "View User",
    element: <ViewUser />,
  },
  {
    path: "/artwork-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Artwork Management",
    element: <ArtWorkManagement />,
  },
  {
    path: "/settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Settings",
    element: <Settings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Notifications",
    element: <Notifications />,
  },
  {
    path: "/contact-us",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Contact Us",
    element: <ContactUs />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    element: <Cms />,
  },
  {
    path: "/crud",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CRUD",
    element: <Cruds />,
  },
];
